import {Route, Routes} from "react-router";
import './App.css';
import Activate from "./pages/Activate";
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ActionContextWrapper from "./context/ActionContextWrapper";
import Reset from "./pages/Reset";
import {AuthProvider} from "./context/AuthContext";
import Login from "./pages/Login";
import SecureApp from "./pages/SecureApp";
import LogoutPage from "./pages/LogoutPage";
import PrivateRoute from "./components/PrivateRoute";

toast.configure()

function App() {
  return (
    <AuthProvider>
      <ActionContextWrapper>
        <Routes>
          <Route path="/activate" element={<Activate/>}/>
          <Route path="/resetPassword" element={<Reset/>}/>
          <Route path="/logout" element={<LogoutPage/>}/>
          <Route exact path="/login" element={<Login/>}/>
          <Route path="/*" element={<PrivateRoute><SecureApp/></PrivateRoute>}/>
        </Routes>
      </ActionContextWrapper>
    </AuthProvider>
  );
}

export default App;
